import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(MotionPathPlugin);

export default class CoreSequence extends DefaultBlock {
	init() {
		this.el = {
			wrapper: this.block.querySelector("#core-sequence-scrubber"),
			backgrounds: this.block.querySelectorAll(".core-sequence-bg"),
			icons: this.block.querySelectorAll(".core-sequence-icon"),
			texts: this.block.querySelectorAll(".core-sequence-text"),
			scrubberLeft: this.block.querySelector("#core-sequence-scrubber-left"),
			scrubberRight: this.block.querySelector("#core-sequence-scrubber-right"),
			timelines: this.block.querySelectorAll("#core-sequence-timelines path"),
			sequence1: this.block.querySelectorAll("#core-sequence-1"),
			sequence2: this.block.querySelectorAll("#core-sequence-2"),
			sequence3: this.block.querySelectorAll("#core-sequence-3"),
			background1: this.block.querySelectorAll(".core-sequence-1-bg"),
			background2: this.block.querySelectorAll(".core-sequence-2-bg"),
			background3: this.block.querySelectorAll(".core-sequence-3-bg"),
			icon1: this.block.querySelectorAll(".core-sequence-1-icon"),
			icon2: this.block.querySelectorAll(".core-sequence-2-icon"),
			icon3: this.block.querySelectorAll(".core-sequence-3-icon"),
			text1: this.block.querySelectorAll(".core-sequence-1-text"),
			text2: this.block.querySelectorAll(".core-sequence-2-text"),
			text3: this.block.querySelectorAll(".core-sequence-3-text"),
			mask: this.block.querySelector(".core-sequence-mask"),
		};

		this.position = null;

		this.initCoreSequence();
	}

	getCoreBounds() {
		this.position = MotionPathPlugin.getRelativePosition(
			this.el.scrubberLeft,
			this.el.scrubberRight,
			[0.5, 0.5],
			[0.5, 0.5]
		);
	}

	setCoreSequence() {
		watchPreferredMotion(() => {
			gsap.set(this.el.icons, {
				scale: 0,
				transformOrigin: "50% 50%",
			});

			gsap.set(this.el.texts, {
				autoAlpha: 0,
				scale: 0.85,
				transformOrigin: "0% 50%",
				x: -20,
			});

			gsap.set(this.el.mask, {
				transformOrigin: "100% 100%",
			});
		});
	}

	playCoreSequence() {
		const tl = gsap.timeline({
			id: "sequence",
			scrollTrigger: {
				trigger: this.el.wrapper,
				start: "top 90%",
				end: "top 20%",
				scrub: 1,
			},
		});

		watchPreferredMotion(() => {
			// Let scrubber run total duration
			tl.to(
				this.el.scrubberLeft,
				{
					x: this.position.x,
					duration: 2,
					ease: "power1.out",
				},
				0
			)
				.to(
					this.el.mask,
					{
						scaleX: 0,
						duration: 2,
						ease: "power1.out",
					},
					0
				)
				.addLabel("sequence1")
				.to(
					this.el.icon1,
					{
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					0.5
				)
				.to(
					this.el.text1,
					{
						autoAlpha: 1,
						x: 0,
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					0.5
				)
				.to(
					this.el.icon1,
					{
						rotate: 360,
						duration: 1,
						stagger: 0.15,
						ease: "back.inOut(1.25)",
					},
					0.8
				)
				.addLabel("sequence2")
				.to(
					this.el.icon2,
					{
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					1
				)
				.to(
					this.el.text2,
					{
						autoAlpha: 1,
						x: 0,
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					1
				)
				.to(
					this.el.icon2,
					{
						rotate: 360,
						duration: 1,
						stagger: 0.15,
						ease: "back.inOut(1.25)",
					},
					1.15
				)
				.addLabel("sequence3")
				.to(
					this.el.icon3,
					{
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					1.4
				)
				.to(
					this.el.text3,
					{
						autoAlpha: 1,
						x: 0,
						scale: 1,
						duration: 0.3,
						ease: "power1.out",
					},
					1.4
				)
				.to(
					this.el.icon3,
					{
						rotate: 360,
						duration: 1,
						stagger: 0.15,
						ease: "back.inOut(1.25)",
					},
					1.6
				);
		});
	}

	initCoreSequence() {
		this.getCoreBounds();
		this.setCoreSequence();
		this.playCoreSequence();

		window.addEventListener("resize", this.getCoreBounds.bind(this));
	}
}
